import {
  RECIPE_PHOTO_JPEG_QUALITY,
  RECIPE_PHOTO_MAX_DIMENSION,
  type RecipePhotoRef,
} from '@awwyeah/shared';
import * as shared from '../../../lib/outbox/image';
import type { PreparedPhoto } from '../../../lib/outbox/image';

export type { PreparedPhoto } from '../../../lib/outbox/image';
export { hasExifSegment, sha256Hex } from '../../../lib/outbox/image';

/** Recipe photo pipeline (WS-20) — the same downscale/EXIF-strip/hash mechanics check-in
 * uses (`apps/web/src/lib/outbox/image.ts`), at the recipe module's own dimension/quality
 * constants. */
export async function preparePhoto(file: Blob): Promise<PreparedPhoto> {
  return shared.preparePhoto(file, {
    maxDimension: RECIPE_PHOTO_MAX_DIMENSION,
    quality: RECIPE_PHOTO_JPEG_QUALITY,
  });
}

/** The Yjs `photoRef` for a freshly prepared photo: on this device only, for now. */
export function localPhotoRef(photo: PreparedPhoto): RecipePhotoRef {
  return { id: photo.id, w: photo.width, h: photo.height, state: 'local' };
}
